import React, { useState, useEffect, useRef } from 'react'
import './CustomTagsInput.css'

function TagsInput(props) {
    const inputRef = useRef(null)

    const parseValue = (value) => {
        if (Array.isArray(value)) {
            return value.filter((tag) => tag)
        } else if (typeof value === 'string') {
            return value
                .split(',')
                .map((tag) => tag.trim())
                .filter((tag) => tag)
        }
        return []
    }

    const [tags, setTags] = useState(parseValue(props.value) || [])

    useEffect(() => {
        setTags(parseValue(props.value) || [])
    }, [props.value])

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                const value = inputRef.current.value.trim()
                if (value) {
                    if (!tags.includes(value)) {
                        handleAddTag(value)
                    }
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [tags])

    const handleAddTag = (value) => {
        if (value) {
            const newTags = [...tags, value]
            setTags(newTags)
            props.onChange(newTags)
            inputRef.current.value = ''
        }
    }

    function handleKeyDown(e) {
        if (e.key !== 'Enter') return
        const value = e.target.value.trim()
        if (!value) return
        if (!tags.includes(value)) {
            handleAddTag(value)
        }
    }

    function removeTag(index) {
        if (index >= 0 && index < tags.length) {
            const newTags = tags.filter((el, i) => i !== index)
            setTags(newTags)
            props.onChange(newTags)
        }
    }

    return (
        <div className="tags-input-container">
            <input
                ref={inputRef}
                onKeyDown={handleKeyDown}
                type="text"
                className="tags-input"
                placeholder={props.placeholder || 'Type something'}
            />
            {tags.length
                ? tags
                      .filter((tag) => tag)
                      .map((tag, index) => (
                          <div className="tag-item" key={index}>
                              <span className="text">{tag}</span>
                              <span
                                  className="close"
                                  onClick={() => removeTag(index)}
                              >
                                  &times;
                              </span>
                          </div>
                      ))
                : null}
        </div>
    )
}

export default TagsInput
